import { Splide, SplideOptions } from '@splidejs/splide'

import { getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'

class VideoSlider {
  private sliderOptions: SplideOptions = {
    focus: 'end',
    gap: '1.25rem',
    type: 'slide'
  }

  private sliders: NodeListOf<HTMLElement>

  constructor() {
    this.sliders = getElements('video-slider')
  }

  public init(): void {
    this.addEvents()
  }

  private addEvents(): void {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.initializeSliders.bind(this), {once: true})
    } else {
      this.initializeSliders()
    }
  }

  private initializeSliders(): void {
    this.sliders.forEach((slider): void => {
      const splide = new Splide(slider, this.sliderOptions)
      splide.mount()

      const slides = slider.querySelectorAll('.splide__slide')
      const controls = slider.querySelector('.splide__controls') as HTMLElement
      const perPage = splide.options.perPage as number

      if (slides.length <= perPage && controls) {
        controls.style.display = 'none'
      }
    })
  }
}

const videoSlider = new VideoSlider()
videoSlider.init()
